import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './OrgSearchDropdown.css';

export default function OrgSearchDropdown({ value, onChange, onRequestOrg, placeholder = 'Search organization...' }) {
  const { getApprovedOrganizations } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    getApprovedOrganizations().then((r) => {
      if (r.success) setOrgs(r.data);
    });
  }, [getApprovedOrganizations]);

  useEffect(() => {
    if (value) setQuery(value.name);
  }, [value]);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const filtered = orgs.filter((o) => o.name.toLowerCase().includes(query.toLowerCase()));

  const handleSelect = (org) => {
    setQuery(org.name);
    setOpen(false);
    onChange(org);
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    // Only open dropdown if there's text in the search
    setOpen(e.target.value.trim().length > 0);
    if (!e.target.value) onChange(null);
  };

  return (
    <div className="osd-wrap" ref={ref}>
      <div className={`osd-input-wrap${open ? ' open' : ''}`}>
        <svg className="osd-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input
          className="osd-input"
          type="text"
          value={query}
          onChange={handleInputChange}
          placeholder={placeholder}
          autoComplete="off"
        />
        {query && (
          <button className="osd-clear" type="button" onClick={() => { setQuery(''); onChange(null); setOpen(false); }}>×</button>
        )}
      </div>

      {open && query.trim().length > 0 && (
        <div className="osd-dropdown">
          {filtered.length === 0 && (
            <div className="osd-empty">No organizations found</div>
          )}
          {filtered.map((org) => (
            <div
              key={org.id}
              className={`osd-option${value?.id === org.id ? ' selected' : ''}`}
              onMouseDown={(e) => { e.preventDefault(); handleSelect(org); }}
            >
              <span className="osd-org-name">{org.name}</span>
              <span className="osd-org-meta">{[org.sport, org.city && org.state ? `${org.city}, ${org.state}` : (org.city || org.state)].filter(Boolean).join(' · ')}</span>
            </div>
          ))}
          {onRequestOrg && (
            <div
              className="osd-request-btn"
              onMouseDown={(e) => { e.preventDefault(); setOpen(false); onRequestOrg(); }}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              Don't see your org? Request it
            </div>
          )}
        </div>
      )}
    </div>
  );
}
